<template>
    <div>
        <div class="container">
            <div class="value-area">
                <span v-if="!cartMode">{{stepperValue}}</span>
                <span v-else class="input-container">
                    <input type="number" v-model="stepperValue" :min="minimum" v-on:change="emitChange()">
                </span>
            </div>
            <div class="action-area" v-if="!cartMode">
                <div class="step step-up" v-on:click="stepUp()">
                    <span>+</span>
                </div>
                <div class="step step-down"
                     v-bind:class="{'minimum': stepperValue === minimum}" v-on:click="stepDown()">
                    <span>-</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        EVENT_STEPPER_CHANGE,
        STEPPER_CART_MODE,
        STEPPER_DEFAULT_MODE,
    } from '../services/constants'

    export default {
        name: 'jabra-stepper',
        props: {
            initialValue: {
                type: Number,
                default: 1,
            },
            mode: {
                type: Number,
                default: STEPPER_DEFAULT_MODE,
            },
        },
        data: function () {
            return {
                stepperValue: this.initialValue,
            }
        },
        computed: {
            minimum() {
                return 1
            },
            cartMode() {
                return this.mode === STEPPER_CART_MODE
            }
        },
        methods: {
            stepUp() {
                this.stepperValue++
                this.emitChange()
            },
            stepDown() {
                if (this.stepperValue > this.minimum) {
                    this.stepperValue--
                    this.emitChange()
                }
            },
            emitChange() {
                this.$emit(EVENT_STEPPER_CHANGE, this.stepperValue)
            }
        },
        created() {
            this.$emit(EVENT_STEPPER_CHANGE, this.stepperValue)
        },
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    $step-button-line-height: 28px;
    $border-props: #cccccc solid 1px;
    .container {
        border: $border-props;
        background: #ffffff;
        @include font-abraham(30px, $font-color-blue, 300);
        display: flex;
    }

    .input-container {
        display: flex;
        height: 40px;
    }

    input {
        @include font-abraham(18px, $grey-1, 300);
        width: calc(100% - 10px);
        border: none;
        text-align: center;
    }

    .value-area {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
    }

    .action-area {
        display: flex;
        flex-direction: column;
        font-size: 20px;
        line-height: $step-button-line-height * 2;
    }

    .step {
        border-left: $border-props;
        line-height: $step-button-line-height;
        padding: 0 7px;
        cursor: not-allowed;
        flex-grow: 1;
        display: flex;
        align-items: center;

        &:not(.minimum) {
            cursor: pointer;
            &:hover {
                background: $grey-3;

                &:active {
                    box-shadow: 1px 0 1px 1px $grey-3;
                }
            }
        }

    }

    .step-up {
        border-bottom: $border-props;
    }

</style>
